import { apiSettings } from '../services/Settings';
import { useLocation } from 'react-router-dom';

export const toAbsolutePath = (uri = '') => {
  return `${apiSettings.baseAssetsUrl}${uri}`;
};

export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
